<template>
  <div class="card text-center">
    <div
      class="card-header d-flex"
      :style="{
        backgroundColor: isPending ? '#ffc107' : 'black',
        padding: '10px',
        color: 'white',
      }"
    >
      <h5 class="flex-grow-1">ICM Banner</h5>
      <span v-if="isPending" class="float-right btn bg-secondary"
        ><i class="fa fa-lock text-white"></i
      ></span>
    </div>
    <div class="card-body">
      <input
        type="text"
        class="form-control mb-4 p-3"
        v-model="icm_banners.name"
      />
      <div class="float-right">
        <button @click="preview()" class="btn bg-light-dark text-dark m-2">Preview</button>
        <button
          v-if="!isApprover && !isPending"
          @click="saveIcmBanner(0)"
          class="btn bg-light-dark text-dark m-2"
        >
          Save Draft
        </button>
        <button
          v-if="!isApprover && !isPending"
          @click="saveIcmBanner(1)"
          class="btn btn-warning text-dark m-2"
        >
          Submit For Approval
        </button>
        <button
          v-if="isApprover && isPending"
          data-bs-toggle="modal"
          data-bs-target="#approveModal"
          class="btn btn-warning text-dark m-2 approveModal"
          @click="openIcmApproval('icmBanner')"
        >
          Approval
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { postRequest } from "@/services/RequestService";

export default {
  props: {
    icm_banners: {
      type: Array, // Adjust the prop type based on your data structure
      required: true,
    },
    isApprover: {
      type: Boolean, // Adjust the prop type based on your data structure
      required: true,
    },
    isPending: {
      type: Boolean, // Adjust the prop type based on your data structure
      required: true,
    },
  },

  data() {
    return {
      isApproved: false,
    };
  },

  methods: {
    openIcmApproval(modalName) {
      document.getElementById("data_id").value = modalName;
    },

    async preview() {
      if (
        this.icm_banners.approval === "Pending" ||
        (this.isApprover && this.icm_banners.approval === "Approved") ||
        this.icm_banners.approval === "Rejected"
      ) {
        window.open("/?preview=1");
      } else {
        let response = await postRequest(
          "/banners/home/icm/" + this.icm_banners.id,
          { name: this.icm_banners.name, approval: 0 },
          true
        );

        if (response.data.success) {
          window.open("/?preview=1");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            window.open("/?preview=1");
          });
        }
      }
    },

    async saveIcmBanner(type) {
      let response = await postRequest(
        "/banners/home/icm/" + this.icm_banners.id,
        { name: this.icm_banners.name, approval: type },
        true
      );

      if (response.data.success) {
        this.$swal({
          icon: response.data.success ? "success" : "error",
          text: response.data.message,
          confirmButtonText: "Close",
        }).then(function () {
          window.location.reload();
        });
      }
    },
  },
};
</script>